import React from "react"
import NewsItem from "./NewsItem"
import classNames from "classnames";
// import Blog from "./Blog"
// import { Link } from "gatsby"
export const NewsList = ({ items, listType}) => {
  // console.log(items);
  return <ul className={classNames("gs-news-list", {"gs-news-list--long": listType === "long"})}>
    {items.map((newsItem)=>{
      return <NewsItem key={newsItem.id} {...newsItem}/>
    })}
  </ul>

}
export default NewsList
